import { Button, Flex, Modal } from "antd";

import React from "react";
import { CustomTitle } from "../../../../common/customTitle";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteStaffByIdAction } from "../../../../../redux/services/staff/staffServices";
import { useTranslation } from "react-i18next";

const StaffDeleteDialog = ({ open, onClose }) => {

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  const {t} = useTranslation();

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* id dependencies */
  const { selectedStaffId } = useSelector((state) => state.staff);
  /* id dependencies */

  /* initial dependencies */
  useEffect(() => {
    if (
      !selectedStaffId ||
      selectedStaffId === "" ||
      selectedStaffId === null ||
      selectedStaffId === undefined
    ) {
      onClose();
    }
  }, [selectedStaffId]);
  /* initial dependencies */

  /* perform delete action */
  const handleDelete = () => {
    if (
      selectedStaffId &&
      selectedStaffId !== "" &&
      selectedStaffId !== null &&
      selectedStaffId !== undefined
    ) {
      const dataToBeSent = {
        selectedStaffId,
      };
      dispatch(deleteStaffByIdAction(dataToBeSent, navigate, setLoading)).then(
        () => {
          onClose();
        }
      );
    }
  };
  /* perform delete action */

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={false}
      confirmLoading={loading}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
        <CustomTitle textDecoration="underline" justifyContent="center">
        {t("Modules.Offer.OfferForm.deleteOffer")}

        </CustomTitle>
        <Title level={2}>{t("deleteTitle")}</Title>
        <Flex gap="1rem" align="center" justify="center">
          <Button type="primary" onClick={handleDelete}>
          {t("confirmationPopup.buttonYesText")}

          </Button>
          <Button type="default" onClick={onClose}>
          {t("confirmationPopup.buttonNoText")}

          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default StaffDeleteDialog;
